import { Link } from "react-router-dom";
import { SocialLinks } from "../../data/layout/Header";
import { dynamicSvg, Image } from "../../utils";
import { PathTypes } from "../../types/Layout";
import { FC } from "react";

const TopBar: FC<PathTypes> = ({ part }) => {
  return (
    <div className={`first-topbar${part === "property-2" ? " bg-topbar" : ""}`}>
      <div className="container">
        <div className="topbar-flex">
          <ul className="topbar-left">
            <li>
              <Image src={dynamicSvg("car2/call.svg")} alt="call" className="img-fluid" />
              <span>(60) 11-6291-4913</span>
            </li>
            <li>
              <Image src={dynamicSvg("car2/mail.svg")} alt="mail" className="img-fluid" />
              <span>general.info@gmail.com</span>
            </li>
          </ul>
          <ul className="topbar-right">
            {SocialLinks.map(({ url, icon }, index) => (
              <li key={index}>
                <Link to={url} target="_blank" rel="noopener noreferrer">
                  <i className={icon} />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
